<template>
  <CRow class="justify-content-center">
    <Modal :modal="modal"></Modal>

    <!-- Content -->
    <CCol col="12">
      <CForm @submit.prevent="send">
        <!-- Back -->
        <CRow>
          <CCol lg="12">
            <div class="d-flex align-items-center justify-content-end mb-3">
              <a
                href="javascript:void(0)"
                @click="$router.go(-1)"
              ><CIcon
                name="cil-arrow-left"
                class="mr-2"
              />Voltar</a>
            </div>
          </CCol>
        </CRow>

        <!-- Title -->
        <CCard>
          <CCardHeader
            class="d-flex justify-content-between align-items-center"
          >
            <h4 class="mb-0">
              {{ $route.params.id ? 'Editar Popup' : 'Cadastrar Popup' }}
            </h4>
            <div class="d-flex align-items-center">
              <div class="ml-2 d-flex align-items-center">
                <label class="mb-0">
                  <b>Status</b>
                </label>
                <CSwitch
                  type="checkbox"
                  color="success"
                  variant="3d"
                  class="mx-2"
                  v-bind="labelIcon"
                  :checked.sync="form.status"
                />
              </div>
            </div>
          </CCardHeader>
        </CCard>

        <!-- Fields -->
        <CCard>
          <CCardHeader
            class="d-flex justify-content-between align-items-center"
          >
            <h5 class="mb-0 d-flex align-items-center">
              <CIcon
                name="cil-justify-center"
                class="mt-md-1 mr-2"
              />
              Informações
              <img
                v-if="languageFlag"
                :src="require(`@/assets/img/flags/${languageFlag}.svg`)"
                alt="Bandeira do idioma"
                class="flag ml-2 mt-sm-1"
              />
            </h5>
          </CCardHeader>

          <CCardBody>
            <CRow>
              <CCol lg="12">
                <CRow>
                  <!-- Language -->
                  <CCol lg="4">
                    <div class="form-group">
                      <label for="">Idioma*</label>

                      <Multiselect
                        :value="languageTargetOptions.find(option => option.value == form.languageTargetSelected)"
                        :options="languageTargetOptions"
                        label="label"
                        track-by="value"
                        placeholder="Idioma"
                        :disabled="true"
                        :required="true"
                        @select="(selected) => form.languageTargetSelected = selected.value"
                      />
                    </div>
                  </CCol>

                  <!-- Type -->
                  <CCol lg="4">
                    <div class="form-group">
                      <label for="">Tipo*</label>

                      <Multiselect
                        :value="typeTargetOptions.find(option => option.value == form.typeTargetSelected)"
                        :options="typeTargetOptions"
                        label="label"
                        track-by="value"
                        placeholder="Tipo"
                        :disabled="processing"
                        :required="true"
                        @select="handleSelectedType"
                      />
                    </div>
                  </CCol>
                </CRow>

                <CRow>
                  <!-- Title -->
                  <CCol lg="4">
                    <CInput
                      v-model="form.title"
                      label="Título*"
                      placeholder="Título do popup"
                      :disabled="processing"
                      required
                    />
                  </CCol>

                  <!-- Link -->
                  <CCol lg="4">
                    <template v-if="form.typeTargetSelected == 1">
                      <CInput
                        v-model="form.url"
                        placeholder="https://www.exemplo.com.br"
                        :disabled="processing"
                        type="url"
                      >
                        <template #label>
                          <label>Link</label>
                        </template>
                      </CInput>
                    </template>

                    <template v-else>
                      <CInput
                        v-model="form.url"
                        :disabled="processing"
                        type="url"
                        required
                        description="Ex: https://www.youtube.com/watch?v=mSdevWYk7Mk"
                      >
                        <template #label>
                          <label>Vídeo* <small class="text-muted">(URL Youtube)</small></label>
                        </template>
                      </CInput>
                    </template>
                  </CCol>
                </CRow>
                <CRow>
                  <CCol lg="4">
                    <div class="form-group">
                      <label for="">Tempo*</label>
                      <Multiselect
                        :value="hasExpirationTimeOptions.find(option => option.value == form.expirationTimeSelected)"
                        :options="hasExpirationTimeOptions"
                        label="label"
                        track-by="value"
                        placeholder="Tempo"
                        :disabled="processing"
                        :required="true"
                        @select="handleSelectedTime"
                      />
                    </div>
                  </CCol>
                  <CCol lg="4">
                    <label>Data de publicação*</label>
                    <Datepicker
                      :value="form.begin_at"
                      :disabled="processing"
                      :required="true"
                      @selected="periodOfSelected"
                    />
                  </CCol>
                  <CCol
                    v-if="form.expirationTimeSelected === 'Determinado'"
                    lg="4"
                  >
                    <label>Data de expiração*</label>
                    <Datepicker
                      :value="form.end_at"
                      :disabled="processing"
                      :required="true"
                      :disabled-dates="periodUntil.disabledDates"
                      @selected="periodUntilSelected"
                    />
                  </CCol>
                </CRow>
              </CCol>
            </CRow>

            <CRow v-if="form.typeTargetSelected == 1">
              <CCol lg="12">
                <FileUploader
                  id="popup-image"
                  :uploader-info="uploaderInfo"
                  :enable-multiple="false"
                  :enable-crop-on-uploader="false"
                  :enable-edit-on-api-table="false"
                  :max-files="1"
                  :accept-types="acceptTypes"
                  :extensions="extensions"
                  :medias="form.main_image"
                  :height="425"
                  :width="752"
                  uploader-type="banner"
                  :disabled="processing"
                />
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>

        <!-- Logs -->
        <CRow v-if="$route.params.id">
          <CCol sm="12">
            <CardLog :log="log" />
          </CCol>
        </CRow>

        <!-- Actions -->
        <div class="form-actions">
          <a
            href="javascript:void(0)"
            class="mr-3"
            @click="clearEdit"
          >Limpar alterações</a>
          <CButton
            color="success"
            type="submit"
            :disabled="processing"
          >
            {{ processing ? 'Salvando...' : 'Salvar' }}
          </CButton>
        </div>
      </CForm>
    </CCol>
  </CRow>
</template>

<script>
// Components
import FileUploader from '@/components/ui/Fileuploader'
import Datepicker from '@/components/ui/Datepicker'
import Modal from '@/components/ui/Modal'
import Multiselect from '@/components/ui/Multiselect'
import CardLog from '@/components/ui/CardLog'

// Dependencies
import moment from 'moment'
import { cloneDeep } from 'lodash'

// Services
import Service from '@/services/popup.service'

export default {
  metaInfo: {
    title: 'Popups',
    titleTemplate: ' %s - Manager - Intelli'
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (!vm.$store.state.auth.permissions.includes('manage_popups')) {
        vm.$router.push('/404')
      }
    })
  },

  components: {
    FileUploader,
    Datepicker,
    Modal,
    Multiselect,
    CardLog
  },

  data() {
    return {
      labelIcon: {
        labelOn: '\u2713',
        labelOff: '\u2715'
      },
      item: {
        status: '',
        language_id: '',
        title: '',
        url: '',
        typeTargetSelected: '',
        begin_at: moment().format('YYYY-MM-DD'),
        end_at: moment().format('YYYY-MM-DD')
      },
      form: {},
      languageTargetOptions: [
        {
          value: '1',
          label: 'Português'
        },
        {
          value: '2',
          label: 'Inglês'
        },
        {
          value: '3',
          label: 'Espanhol'
        }
      ],
      typeTargetOptions: [
        {
          value: '1',
          label: 'Imagem'
        },
        {
          value: '2',
          label: 'Vídeo'
        }
      ],
      hasExpirationTimeOptions: [
        {
          value: 'Determinado',
          label: 'Determinado'
        },
        {
          value: 'Indeterminado',
          label: 'Indeterminado'
        }
      ],
      acceptTypes: 'image/png,image/jpeg',
      extensions: 'jpg,jpeg,png',
      uploaderInfo: {
        label: 'Imagem'
      },
      hasLinkOptions: [
        {
          value: '0',
          label: 'Não'
        },
        {
          value: '1',
          label: 'Sim'
        }
      ],
      media: [],
      log: {
        created_by: '',
        created_at: '',
        updated_by: '',
        updated_at: ''
      },
      processing: false,
      new: true,
      query: {
        sorter: {}
      },
      modal: {
        show: false,
        title: '',
        message: '',
        color: ''
      },
      baseUrl: '',
      periodUntil: {
        disabledDates: {
          from: '',
          to: ''
        }
      }
    }
  },

  computed: {
    languageFlag() {
      const languageId = parseInt(this.form.language_id)

      if (languageId === 1) {
        return 'pt-br'
      } else if (languageId === 2) {
        return 'en'
      } else if (languageId === 3) {
        return 'es'
      } else {
        return null
      }
    }
  },

  async created() {
    this.setItem()
  },

  methods: {
    async setItem() {
      if (this.$route.params.id) {
        const data = await Service.show(this.$route.params.id)

        if (data) {
          this.item = {
            ...data,
            status: !!data.status,
            typeTargetSelected: data.type,
            languageTargetSelected: data.language_id,
            expirationTimeSelected: data.statusTime
          }

          if (data.end_at && data.begin_at) {
            this.item.expirationTimeSelected = 'Determinado'
            this.item.begin_at = data.begin_at
            this.item.end_at = data.end_at
          } else {
            this.item.expirationTimeSelected = 'Indeterminado'
            this.item.begin_at = data.begin_at
          }

          this.log = {
            created_by: data.created ? data.created.name : 'Seed',
            created_at: moment(data.created_at).format('DD/MM/YYYY HH:mm'),
            updated_by: data.updated ? data.updated.name : null,
            updated_at: moment(data.updated_at).format('DD/MM/YYYY HH:mm')
          }
        }
      }

      this.form = cloneDeep(this.item)
      this.handlePeriodUntil()
    },

    clearEdit() {
      this.form = cloneDeep(this.item)
    },

    handleSelectedType(selected) {
      this.form.typeTargetSelected = selected.value
      this.form.url = ''
    },

    handleSelectedTime(selected) {
      this.form.expirationTimeSelected = selected.value
      this.handlePeriodUntil()
    },

    handlePeriodUntil() {
      // Set disabled dates
      const periodOfDate = moment(this.form.begin_at).toDate()
      this.periodUntil.disabledDates.to = periodOfDate

      // Handle periof of bigger than periof until
      if (moment(this.form.begin_at).isAfter(this.form.end_at)) {
        this.form.end_at = periodOfDate
      }
    },

    periodOfSelected(date) {
      const dateFormatted = moment(date).toDate()

      this.form.begin_at = dateFormatted
      this.handlePeriodUntil()
    },

    periodUntilSelected(date) {
      this.form.end_at = moment(date).toDate()
    },

    async send() {
      this.processing = true

      if (this.form.typeTargetSelected === 2) {
        const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/
        const match = this.form.url.match(regExp)
        if (!match) {
          this.processing = false
          this.modal = {
            show: true,
            title: 'Erro',
            message: 'Por favor adicione uma URL do youtube',
            color: 'danger'
          }
          return
        }
      }

      const data = {
        id: this.$route.params.id,
        status: this.form.status,
        language_id: this.form.language_id,
        title: this.form.title,
        url: this.form.url,
        type: this.form.typeTargetSelected,
        main_image_id: this.form.main_image && this.form.main_image.length > 0 ? this.form.main_image[0].id : null
      }

      if (this.form.expirationTimeSelected === 'Determinado') {
        data.begin_at = moment(this.form.begin_at).format('YYYY-MM-DD')
        data.end_at = moment(this.form.end_at).format('YYYY-MM-DD')
      } else {
        data.begin_at = moment(this.form.begin_at).format('YYYY-MM-DD')
        data.end_at = null
      }

      const response = await Service.update(this.$route.params.id, data)
      const message = 'Popup foi atualizado com sucesso!'

      this.processing = false

      if (response.status === 200) {
        this.modal = {
          show: true,
          title: 'Sucesso',
          message: message,
          color: 'success',
          redirect: true
        }

        setTimeout(() => {
          this.processing = false
          this.modal.show = false
          this.$router.push(
            this.$route.matched[this.$route.matched.length - 2].path
          )
        }, 3000)
      } else if (response.status === 400) {
        this.modal = {
          show: true,
          title: 'Erro',
          message: (response.data.messages && response.data.messages.length > 0 && response.data.messages[0].message) || response.data,
          color: 'danger'
        }
      } else {
        this.modal = {
          show: true,
          title: 'Erro',
          message: 'Ocorreu um erro interno, por favor tente novamente!',
          color: 'danger'
        }
      }
    }
  }
}
</script>
